import { useEffect, useState } from 'react';

import { breakpoints } from '../server/constants';

export const useIsMobileScreenSize = () => {
	const [isMobile, setIsMobile] = useState(() => {
		if (typeof window !== 'undefined') {
			return window.innerWidth < breakpoints.sm;
		}
		return false;
	});

	useEffect(() => {
		if (typeof window === 'undefined') return;

		const checkIsMobile = () => {
			setIsMobile(window.innerWidth < breakpoints.sm);
		};

		window.addEventListener('resize', checkIsMobile);
		return () => {
			window.removeEventListener('resize', checkIsMobile);
		};
	}, []);

	return isMobile;
};
